import { fromJS } from "immutable";

import { groupByProductsActions } from "actions/groupByProductsActions.js";
import { groupByBannerActions } from "actions/groupByBannerActions.js";
import { filterActions } from "actions/filterActions.js";

import { CATALOGUE_ORDER, RANGE } from "constants.js";

import { humanize } from "utils.js";
import { productsActions } from "actions/productsActions";

const initialState = fromJS({
  isLoading: true,
  error: null,
  data: {
    selectedGroupByFilter: {
      label: humanize(CATALOGUE_ORDER),
      value: CATALOGUE_ORDER
    },
    manualOverride: false,
    prs: {}
  }
});

export default (state = initialState, action) => {
  let obj = {},
    key;
  switch (action.type) {
    case groupByProductsActions.reset:
    case groupByBannerActions.reset:
      return state.setIn(["data", "prs"], fromJS({}));
    case filterActions.setActiveTab:
      // The Buy Plan and Summary tabs fetch filters scoped to the buyplan's items
      // into the same store. Their responses must not choose the catalog grouping,
      // or returning to the catalog renders only the sections that have items -
      // and, grouped, never refetches the catalog's own filters.
      if (action.payload.activeTab !== RANGE.toLowerCase()) {
        return initialState.set("offRangeTab", true);
      }

      return state.delete("offRangeTab");
    case groupByProductsActions.success:
      key = action.payload.data.subcategory.name;
      obj[key] = fromJS({
        pr: action.payload.data.pr,
        count: action.payload.data.count
      });
      return state
        .merge({
          isLoading: false,
          error: null
        })
        .mergeDeepIn(["data", "prs"], obj);
    case groupByProductsActions.alterSelectedGroupByFilter:
      return state
        .merge({ isLoading: true })
        .setIn(["data", "manualOverride"], true)
        .setIn(
          ["data", "selectedGroupByFilter"],
          fromJS(action.payload.selectedGroupByFilter)
        );
    case groupByBannerActions.success:
      const selectedFilter = state.getIn([
        "data",
        "selectedGroupByFilter",
        "value"
      ]);
      key = Object.keys(action.payload.data[selectedFilter])[0]; //generate subcategory key dynamically
      obj[key] = fromJS({
        banner_url: action.payload.data[selectedFilter][key]["banner_url"]
      });
      return state
        .merge({
          isLoading: false
        })
        .mergeDeepIn(["data", "prs"], obj);
    case groupByProductsActions.startLoader:
      return state
        .merge({ isLoading: true })
        .setIn(["data", "prs"], fromJS({}));
    case productsActions.success:
      const subcategory = action.payload.data.subcategory;

      return state.mergeIn(
        ["data", "prs", subcategory && subcategory.name, "pr"],
        fromJS(action.payload.data.pr)
      );
    case filterActions.success:
      if (!state.getIn(["data", "manualOverride"]) && !state.get("offRangeTab")) {
        const appliedTellStoryByRaw =
          action?.payload?.data?.applied_filters?.tell_story_by;
        const defaultTellStoryByRaw = action?.payload?.data?.default_tell_story_by;

        // Treat blank string as missing (legacy/invalid data).
        const appliedTellStoryBy =
          typeof appliedTellStoryByRaw === "string"
            ? appliedTellStoryByRaw.trim()
            : appliedTellStoryByRaw;
        const defaultTellStoryBy =
          typeof defaultTellStoryByRaw === "string"
            ? defaultTellStoryByRaw.trim()
            : defaultTellStoryByRaw;

        // A saved tell_story_by is only used when the payload carries options for
        // it; otherwise the release default wins. When the payload carries no
        // dynamic_filters at all we cannot judge, so we trust the value.
        const dynamicFilters =
          action?.payload?.data?.dynamic_filters ||
          action?.payload?.data?.fetchedFilters?.dynamic_filters;
        const hasGroups = key => {
          if (!key) return false;
          if (key === CATALOGUE_ORDER || !dynamicFilters) return true;

          const groups = dynamicFilters[key];

          return Boolean(groups) && groups.length > 0;
        };

        // Precedence:
        // 1) explicit saved tell_story_by (non-blank, with data)
        // 2) release default_tell_story_by - kept even when it has no data, so
        //    Tell Story By still shows the release's choice on an empty catalog;
        //    RangeContainer renders the ungrouped list until there is data
        // 3) "range"
        const selectedStoryByFilter =
          (hasGroups(appliedTellStoryBy) && appliedTellStoryBy) ||
          defaultTellStoryBy ||
          CATALOGUE_ORDER;

        const labelKey =
          selectedStoryByFilter === "filter_tags"
            ? "categories"
            : selectedStoryByFilter;

        return state.setIn(
          ["data", "selectedGroupByFilter"],
          fromJS({
            label: humanize(labelKey),
            value: selectedStoryByFilter
          })
        );
      } else {
        return state;
      }
    default:
      return state;
  }
};
